export const website_domain = 'app.deriv.com';
export const website_name = 'Deriv';
export const default_title = website_name;
export const TRACKING_STATUS_KEY = 'tracking_status';
